import React, { Fragment } from 'react';
import { BaseInfo } from './baseinfo';
import { AdditionInfo } from './addition';
import { ApplyInfo } from './apply';
import './index.scss';
import { useSimpleContext } from '../_context';

import { Loading } from '@roo/roo';

export const Innovate = () => {
  const { state } = useSimpleContext((s) => [s.step, s.innovate, s.loading]);

  if (state.loading) {
    return <Loading backdrop={true} fullscreen={true} visible={state.loading} />;
  }
  const formViews = [null, BaseInfo, AdditionInfo, ApplyInfo];
  const FormView = formViews[state.step];
  return <FormView />;
};
